import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import DashboardRedirect from './dashboard-redirect';


// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
const OverviewEcommercePage = lazy(() => import('src/pages/dashboard/ecommerce'));
const OverviewintelligencePage = lazy(() => import('src/pages/dashboard/intelligence'));
const OverviewintelligenceTheratPage = lazy(() => import('src/pages/dashboard/intelligence-therat'));



const OverviewTakeDownRequest = lazy(() => import('src/sections/overview/TakeDown-Request/view/overview-TakeDownRequest-view'));
const OverviewTakeDownRequestMainPage = lazy(() => import('src/sections/overview/TakeDown-Request/view/overview-TakeDownRequest-Main'));

const IntelligenceView = lazy(() => import('src/sections/overview/intelligence-post-view/view/overview-ecommerce-view'));
const IntelligenceNewEditForm = lazy(() => import('src/sections/overview/intelligence/Intelligence-new-edit-form'));
const IntelligenceViewNewEditForm = lazy(() => import('src/sections/overview/intelligence-post-view/intelligenceView-new-edit-form'));
const OverviewGeneratedApiView = lazy(() => import('src/sections/overview/api-Token/view/overview-GeneratedApi-view'));
const OverviewRolesView = lazy(() => import('src/sections/overview/roles/view/overview-roles-view'));
const GraphCreatePage = lazy(() => import('src/sections/overview/grafhPage/grafh-create-page'));
const ShowDescriptionPage = lazy(() => import('src/sections/overview/intelligence/show-description'));


const ServicePage = lazy(() => import('src/pages/dashboard/servicePage'));
const OverviewAnalyticsPage = lazy(() => import('src/pages/dashboard/analytics'));
const BulkUploadPage = lazy(() => import('src/pages/dashboard/bulkUpload'));
const OverviewBankingPage = lazy(() => import('src/pages/dashboard/banking'));
const OverviewBookingPage = lazy(() => import('src/pages/dashboard/booking'));
const OverviewFilePage = lazy(() => import('src/pages/dashboard/file'));
// PRODUCT
const ProductDetailsPage = lazy(() => import('src/pages/dashboard/product/details'));
const ProductListPage = lazy(() => import('src/pages/dashboard/product/list'));
const ProductCreatePage = lazy(() => import('src/pages/dashboard/product/new'));
const ProductEditPage = lazy(() => import('src/pages/dashboard/product/edit'));
// ORDER
const OrderListPage = lazy(() => import('src/pages/dashboard/order/list'));
const OrderDetailsPage = lazy(() => import('src/pages/dashboard/order/details'));
// INVOICE
const InvoiceListPage = lazy(() => import('src/pages/dashboard/invoice/list'));
const InvoiceDetailsPage = lazy(() => import('src/pages/dashboard/invoice/details'));
const InvoiceCreatePage = lazy(() => import('src/pages/dashboard/invoice/new'));
const InvoiceEditPage = lazy(() => import('src/pages/dashboard/invoice/edit'));
// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
const Takedownrequest = lazy(() => import('src/pages/dashboard/report/takedownrequest'));
const UserEditProfilePage = lazy(() => import('src/sections/user/users/EditUserProfile'));

const UserCardsPage = lazy(() => import('src/pages/dashboard/user/cards'));
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/user/new'));
const UserEditPage = lazy(() => import('src/pages/dashboard/user/edit'));
const ComapnyCreateView = lazy(() => import('src/sections/overview/e-commerce/view/company-create-view'));
const ServiceCreateView = lazy(() => import('src/sections/overview/service/view/service-create-view'));


// import ComapnyCreateView from 'src/sections/overview/e-commerce/view/company-create-view';

// BLOG
const BlogPostsPage = lazy(() => import('src/pages/dashboard/post/list'));
const BlogPostPage = lazy(() => import('src/pages/dashboard/post/details'));
const BlogNewPostPage = lazy(() => import('src/pages/dashboard/post/new'));
const BlogEditPostPage = lazy(() => import('src/pages/dashboard/post/edit'));
// JOB
const JobDetailsPage = lazy(() => import('src/pages/dashboard/job/details'));
const JobListPage = lazy(() => import('src/pages/dashboard/job/list'));
const JobCreatePage = lazy(() => import('src/pages/dashboard/job/new'));
const JobEditPage = lazy(() => import('src/pages/dashboard/job/edit'));
// TOUR
const TourDetailsPage = lazy(() => import('src/pages/dashboard/tour/details'));
const TourListPage = lazy(() => import('src/pages/dashboard/tour/list'));
const TourCreatePage = lazy(() => import('src/pages/dashboard/tour/new'));
const TourEditPage = lazy(() => import('src/pages/dashboard/tour/edit'));

// sam
const IssuesPage = lazy(() => import('src/pages/dashboard/asm/list'));
const AssetsPage = lazy(() => import('src/pages/dashboard/asm/assets'));
const AsmPortList = lazy(() => import('src/sections/asm/asm-port'));
const AsmReportList = lazy(() => import('src/sections/asm/asm-report'));
const EditReportPage = lazy(() => import('src/sections/asm/edit-report'));
const CraeteReportPage = lazy(() => import('src/sections/asm/create-report'));

// FILE MANAGER
const FileManagerPage = lazy(() => import('src/pages/dashboard/file-manager'));
// APP
const ChatPage = lazy(() => import('src/pages/dashboard/chat'));
const MailPage = lazy(() => import('src/pages/dashboard/mail'));
const CalendarPage = lazy(() => import('src/pages/dashboard/calendar'));
const OverviewDashboard = lazy(() => import('src/pages/dashboard/overviewDashboard'));


const KanbanPage = lazy(() => import('src/pages/dashboard/kanban'));
// TEST RENDER PAGE BY ROLE
const PermissionDeniedPage = lazy(() => import('src/pages/dashboard/permission'));
// BLANK PAGE
const BlankPage = lazy(() => import('src/pages/dashboard/blank'));
// REPORT 


const CompanyReportListPAge = lazy(() => import('src/sections/user/report/company-report-list'));
const TakeDownRequestList = lazy(() => import('src/sections/user/report/takedown-request-list'));
const OverviewVendorPerformanceView = lazy(() => import('src/sections/overview/vendor-Performance/view/overview-VendorPerformance-view'));

const DetectionByModuleList = lazy(() => import('src/sections/user/report/detection-by-module-list'));
const ModuleWiseBreakupList = lazy(() => import('src/sections/user/report/modulewise-breakup'));
const TatForTakeDownsList = lazy(() => import('src/sections/user/report/tat-for-takedowns'));
const AverageTakeDownTimeList = lazy(() => import('src/sections/user/report/average-takedown-time'));
const CumulativeTakedownTrendList = lazy(() => import('src/sections/user/report/cumulative-takedown-trend'));
const SocialMediaDetectionList = lazy(() => import('src/sections/user/report/social-media-detection'));
const AddcompanyReportPage = lazy(() => import('src/sections/user/report/addcompanyreport'));
const DarkWebMentionsList = lazy(() => import('src/sections/user/report/dark-web-mentions-list'));
const EditCompanyReportPage = lazy(() => import('src/sections/user/report/editcompanyreport'));
const ScheduleReportPage = lazy(() => import('src/sections/user/report/schedule-report'));
const UserScheduleReportPage = lazy(() => import('src/sections/user/report/user-schedule-report'));
const SocialMediaTreeReportPage = lazy(() => import('src/sections/user/report/soical-media-treechart'));
const UpdateAsmPermissionPage = lazy(() => import('src/sections/user/asm-permission/update-asm-permission'));
const GetAsmPermissionPage = lazy(() => import('src/sections/user/asm-permission/view-list-asm-permission'));
const EditAsmPermissionPage = lazy(() => import('src/sections/user/asm-permission/Edit-asm-permission'));
const LoginLogoutPage = lazy(() => import('src/sections/user/report/login-logout-history'));
const DarkWebmentionThreat = lazy(() => import('src/sections/user/report/dark-web-threat'));
// ----------------------------------------------------------------------

// Companies

// USERS

const UsersListPage = lazy(() => import('src/sections/user/users/userslist-view'));
const CreateUserPage = lazy(() => import('src/sections/user/users/create-user'));
const EditUserPage = lazy(() => import('src/sections/user/users/editUser'));

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      // { element: <DashboardRedirect />, index: true },
      { path: 'company', element: <OverviewEcommercePage /> },

      { path: 'intelligence/:idService/:serviceName', element: <OverviewintelligencePage /> },
      { path: 'intelligenceTherat/:idService/:serviceName', element: <OverviewintelligenceTheratPage /> },


      { path: 'takedownrequest/:idService/:serviceName', element: <OverviewTakeDownRequest /> },
      { path: 'takedownrequestMainPage/:idService/:serviceName/:idCompany', element: <OverviewTakeDownRequestMainPage /> },

      { path: ':idService/:companyId/:serviceName/intelligenceView', element: <IntelligenceView /> },
      { path: ':idService/:serviceName/intelligenceNewEditForm', element: <IntelligenceNewEditForm /> },
      { path: ':id/:idService/:companyId/:serviceName/intelligenceViewNewEditForm', element: <IntelligenceViewNewEditForm /> },
      { path: 'generatedApiView', element: <OverviewGeneratedApiView /> },
      { path: 'graphCreatePage', element: <GraphCreatePage /> },
      { path: 'ServicePage', element: <ServicePage /> },
      { path: 'analytics', element: <OverviewAnalyticsPage /> },
      { path: 'bulkUploadPage', element: <BulkUploadPage /> },
      { path: 'banking', element: <OverviewBankingPage /> },
      { path: 'booking', element: <OverviewBookingPage /> },
      { path: 'file', element: <OverviewFilePage /> },
      { path: 'users', element: <UsersListPage /> },
      { path: 'addusers', element: <CreateUserPage /> },
      { path: ':id/editUser', element: <EditUserPage /> },
      { path: 'rolesCreateView', element: <OverviewRolesView /> },
      { path: ':id/showDescriptionPage', element: <ShowDescriptionPage /> },
      { path: 'socialmediatree', element: <SocialMediaTreeReportPage /> },
      { path: 'loginlogout', element: <LoginLogoutPage /> },
      { path: 'darkwebmentionthreat', element: <DarkWebmentionThreat /> },
      { path: 'Asmpermission', element: <UpdateAsmPermissionPage /> },
        { path: 'AsmviewList', element: <GetAsmPermissionPage /> },
             { path: ':id/editasmpermission', element: <EditAsmPermissionPage /> },

      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          { path: 'cards', element: <UserCardsPage /> },
          { path: 'list', element: <UserListPage /> },
          { path: 'new', element: <UserCreatePage /> },
          { path: ':id/edit', element: <UserEditPage /> },
          { path: 'account', element: <UserAccountPage /> },
          { path: ':id/comapnyCreateView', element: <ComapnyCreateView /> },
          { path: 'ServiceCreateView', element: <ServiceCreateView /> },

        ],
      },

      {
        path: 'editprofile',
        children: [
          { element: <UserEditProfilePage />, index: true },
          { path: ':id/editprofile', element: <UserEditProfilePage /> },


        ],
      },



      // report



      {
        path: 'report',
        children: [
          { element: <CompanyReportListPAge />, index: true },
          { path: 'reportlist', element: <CompanyReportListPAge /> },
          { path: 'vendorPerformance', element: <OverviewVendorPerformanceView /> },
          { path: 'schedulereport', element: <ScheduleReportPage /> },
          { path: 'takedownrequestlist', element: <TakeDownRequestList /> },
          { path: 'detectionbymodule', element: <DetectionByModuleList /> },
          { path: 'modulewisebreakuplist', element: <ModuleWiseBreakupList /> },
          { path: 'tatfortakedownslist', element: <TatForTakeDownsList /> },
          { path: 'averagetakedowntime', element: <AverageTakeDownTimeList /> },
          { path: 'cumulativetakedowntrend', element: <CumulativeTakedownTrendList /> },
          { path: 'socialmediadetection', element: <SocialMediaDetectionList /> },
          { path: 'addcompanyreport', element: <AddcompanyReportPage /> },
          { path: 'darkwebmentions', element: <DarkWebMentionsList /> },
          { path: ':id/editcompanyReport', element: <EditCompanyReportPage /> },


        ],
      },

         { path: 'userreport', element: <UserScheduleReportPage /> },

      // companies



      {
        path: 'report',
        children: [
          { element: <Takedownrequest />, index: true },
          { path: 'takedownrequest', element: <Takedownrequest /> },
        ],
      },
      {
        path: 'asm',
        children: [
          { element: <IssuesPage />, index: true },
          { path: 'issues', element: <IssuesPage /> },
          { path: 'assets', element: <AssetsPage /> },
          { path: 'portlist', element: <AsmPortList /> },
          { path: 'reportlist', element: <AsmReportList /> },
          { path: 'addreport', element: <CraeteReportPage /> },
          { path: ':id/edit', element: <EditReportPage /> },
          // { path: 'reportlist', element: <AsmReportList /> },


        ],
      },

      {
        path: 'product',
        children: [
          { element: <ProductListPage />, index: true },
          { path: 'list', element: <ProductListPage /> },
          { path: ':id', element: <ProductDetailsPage /> },
          { path: 'new', element: <ProductCreatePage /> },
          { path: ':id/edit', element: <ProductEditPage /> },
        ],
      },
      {
        path: 'order',
        children: [
          { element: <OrderListPage />, index: true },
          { path: 'list', element: <OrderListPage /> },
          { path: ':id', element: <OrderDetailsPage /> },
        ],
      },
      {
        path: 'invoice',
        children: [
          { element: <InvoiceListPage />, index: true },
          { path: 'list', element: <InvoiceListPage /> },
          { path: ':id', element: <InvoiceDetailsPage /> },
          { path: ':id/edit', element: <InvoiceEditPage /> },
          { path: 'new', element: <InvoiceCreatePage /> },
        ],
      },
      {
        path: 'post',
        children: [
          { element: <BlogPostsPage />, index: true },
          { path: 'list', element: <BlogPostsPage /> },
          { path: ':title', element: <BlogPostPage /> },
          { path: ':title/edit', element: <BlogEditPostPage /> },
          { path: 'new', element: <BlogNewPostPage /> },
        ],
      },
      {
        path: 'job',
        children: [
          { element: <JobListPage />, index: true },
          { path: 'list', element: <JobListPage /> },
          { path: ':id', element: <JobDetailsPage /> },
          { path: 'new', element: <JobCreatePage /> },
          { path: ':id/edit', element: <JobEditPage /> },
        ],
      },
      {
        path: 'tour',
        children: [
          { element: <TourListPage />, index: true },
          { path: 'list', element: <TourListPage /> },
          { path: ':id', element: <TourDetailsPage /> },
          { path: 'new', element: <TourCreatePage /> },
          { path: ':id/edit', element: <TourEditPage /> },
        ],
      },
      { path: 'file-manager', element: <FileManagerPage /> },
      { path: 'mail', element: <MailPage /> },
      { path: 'chat', element: <ChatPage /> },
      { path: 'calendar', element: <CalendarPage /> },
      // { path: 'overviewDashboard', element: <OverviewDashboard /> },


      { path: 'kanban', element: <KanbanPage /> },
      { path: 'permission', element: <PermissionDeniedPage /> },
      { path: 'blank', element: <BlankPage /> },
    ],
  },
];


